import React from 'react'
import { DatePicker, InputNumber, Segmented, Select } from 'antd'
import dayjs from 'dayjs'
import { Calculator, TriangleAlert } from 'lucide-react'
import { Field } from './Field'
import { EmptyRow, TableWrap, Td, Th } from './Table'
import { DATE_FORMAT, PLAN_TYPE_OPTIONS } from '../constants'
import { formatMoney } from '../utils'
import { scheduleTotal } from '../installments'


const InstallmentSchedule = ({
	planType,
	monthOptions,
	plansFallback,
	months,
	percent,
	rows,
	total,
	error,
	onPlanTypeChange,
	onMonthsChange,
	onPercentChange,
	onAmountChange,
	onDateChange,
	onRecalculate,
}) => {
	const planned = scheduleTotal(rows)
	const diff = Math.round((planned - total) * 100) / 100

	return (
		<div className="flex flex-col gap-4">
			{/* Eskisidagi «Месяц» / «Месяц B2B» tanlovi — tariflar SAP dan kelgandagina */}
			<div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
				{!plansFallback && (
					<Field label="Tarif">
						<Segmented
							block
							value={planType}
							onChange={onPlanTypeChange}
							options={PLAN_TYPE_OPTIONS}
						/>
					</Field>
				)}

				<Field label="Muddat (oy)" required>
					<Select
						className="w-full"
						value={months || undefined}
						onChange={onMonthsChange}
						placeholder="Oylar soni"
						options={monthOptions}
					/>
				</Field>

				<Field
					label="Ustama (%)"
					hint={
						plansFallback
							? 'Qolgan qarzga qo‘shiladi'
							: 'Muddat bilan avtomatik to‘ladi'
					}
				>
					<InputNumber
						className="w-full"
						min={0}
						max={200}
						value={percent}
						onChange={onPercentChange}
						placeholder="0"
					/>
				</Field>

				<div className="flex items-end">
					<button
						type="button"
						onClick={onRecalculate}
						className="inline-flex h-8 items-center justify-center gap-2 rounded-xl border border-slate-200 px-4 text-sm font-medium text-slate-600 transition hover:border-slate-300"
					>
						<Calculator size={15} /> Hisoblash
					</button>
				</div>
			</div>

			{error && <p className="text-[12px] text-rose-500">{error}</p>}

			<TableWrap minWidth="min-w-[560px]">
				<thead>
					<tr>
						<Th className="w-12">№</Th>
						<Th>Sana</Th>
						<Th align="right">To‘lov summasi</Th>
						<Th>Izoh</Th>
					</tr>
				</thead>
				<tbody>
					{rows.length === 0 && (
						<EmptyRow
							colSpan={4}
							text="Muddatni tanlang — grafik shu yerda chiqadi"
						/>
					)}
					{rows.map((row, index) => (
						<tr key={row.key} className={index === 0 ? 'bg-slate-50/70' : ''}>
							<Td className="font-semibold text-slate-700">{index}</Td>
							<Td>
								<DatePicker
									className="w-full"
									format={DATE_FORMAT}
									allowClear={false}
									value={row.date ? dayjs(row.date, DATE_FORMAT) : null}
									onChange={(date) => onDateChange(index, date)}
								/>
							</Td>
							<Td>
								<InputNumber
									className="w-full"
									min={0}
									value={row.amount}
									onChange={(value) => onAmountChange(index, value)}
								/>
							</Td>
							<Td className="text-[12px] text-slate-400">
								{index === 0
									? 'Boshlang‘ich to‘lov'
									: index === 1
										? 'Qolgan oylarga tarqaladi'
										: ''}
							</Td>
						</tr>
					))}
				</tbody>
			</TableWrap>

			{rows.length > 0 && (
				<div className="flex flex-wrap items-center justify-between gap-3 rounded-xl bg-slate-50 px-4 py-3 text-[13px]">
					<span className="text-slate-500">
						Grafik summasi:{' '}
						<span className="font-semibold text-slate-900">
							{formatMoney(planned, { fallback: '0' })}
						</span>
					</span>
					{diff !== 0 && (
						<span className="inline-flex items-center gap-1.5 text-amber-600">
							<TriangleAlert size={14} />
							{`Tovarlar summasidan farqi: ${formatMoney(diff, { fallback: '0' })}`}
						</span>
					)}
				</div>
			)}
		</div>
	)
}

export default InstallmentSchedule
